import React, { useState } from 'react';
import { Specialty } from 'types/specialty';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { toast } from 'react-toastify';
import history from 'services/history';
import { api } from 'services/api';
import DataGridList from 'components/data-grid/DataGridList';
import InsideSaving from 'components/loading/InsideSaving';
import { specialtyTableTemplate } from '../../template/specialtyTableTemplate';

type SpecialtyListTableProps = {
  specialties: Specialty[];
  handleSearch(): void;
};

const SpecialtyListTable: React.FC<SpecialtyListTableProps> = ({ specialties, handleSearch }) => {
  const [deleting, setDeleting] = useState(false);

  function handleDelete(specialty: Specialty) {
    setDeleting(true);

    api
      .delete(`/specialties/${specialty.id}`)
      .then(() => {
        toast.success('Especialidade excluída com sucesso');
        handleSearch();
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Erro ao excluir especialidade');
      })
      .finally(() => setDeleting(false));
  }

  return (
    <>
      {deleting && <InsideSaving />}
      <DataGridList
        template={specialtyTableTemplate}
        rows={specialties}
        getRowId={row => row.id}
        renderCells={{
          deleteAction: row => (
            <IconButton
              onClick={e => {
                e.stopPropagation();
                handleDelete(row);
              }}
              size="small"
              color="error"
            >
              <Delete fontSize="small" />
            </IconButton>
          ),
        }}
        onRowClick={row => history.push(`/specialties/${row.id}`)}
        fileName="especialidades"
        sheetName="Especialidades"
      />
    </>
  );
};

export default SpecialtyListTable;
